/**
 * @file PortalTabBar.js
 * @description Shared desktop tab bar component with scroll arrows and drag-to-scroll.
 * Used by IndividualHomePage and ViewLivePage.
 */
import { useTheme } from '../../store/ThemeContext';

function PortalTabBar({
    visibleTabs,
    selectedTabId,
    showLeftArrow,
    showRightArrow,
    scroll,
    openTab,
    handleMouseDown,
    handleMouseLeave,
    handleMouseUp,
    handleMouseMove,
}) {
    const themeStyles = useTheme();

    return (
        <div className="tabContainer">
            {showLeftArrow && (
                <button className="scrollButton" onClick={() => scroll('L')}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="14"
                        viewBox="0 0 8 14"
                        fill="none"
                    >
                        <g transform="scale(-1, 1) translate(-8, 0)">
                            <path
                                d="M1.06494 12.7483L7.10066 7.11968L1.13661 1.41518"
                                stroke="var(--iNGAGED-Sub-Text)"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </g>
                    </svg>
                </button>
            )}
            <div
                className="tabs"
                onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseLeave}
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
            >
                {visibleTabs.map(tab => (
                    <div
                        key={tab.id}
                        className={`tab ${tab.id === selectedTabId ? 'active' : 'inactive'}`}
                        style={
                            tab.id === selectedTabId
                                ? {
                                      borderBottomColor:
                                          themeStyles?.accessoriesBg1,
                                      ...(window.innerWidth <= 768 && {
                                          backgroundColor:
                                              themeStyles?.accessoriesBg1,
                                          borderColor:
                                              themeStyles?.accessoriesBg1,
                                      }),
                                  }
                                : {}
                        }
                    >
                        <button
                            className="tabLinks"
                            onClick={() => openTab(tab)}
                            style={
                                tab.id === selectedTabId
                                    ? {
                                          color:
                                              window.innerWidth <= 768
                                                  ? themeStyles?.accessoriesFg1
                                                  : 'var(--iNGAGED-Neutral-Color)',
                                          fontWeight:
                                              window.innerWidth <= 768
                                                  ? 'normal'
                                                  : 'bold',
                                      }
                                    : {}
                            }
                        >
                            {tab.displayName || tab.name}
                        </button>
                    </div>
                ))}
            </div>
            {showRightArrow && (
                <button className="scrollButton" onClick={() => scroll('R')}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="8"
                        height="14"
                        viewBox="0 0 8 14"
                        fill="none"
                    >
                        <path
                            d="M1.06494 12.7483L7.10066 7.11968L1.13661 1.41518"
                            stroke="var(--iNGAGED-Sub-Text)"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
            )}
        </div>
    );
}

export default PortalTabBar;
